// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckboxGroup_container__7y5h5","fieldset":"CheckboxGroup_fieldset__kzp39","legend":"CheckboxGroup_legend__pu5K4","columns":"CheckboxGroup_columns__9g6J9"};